import React, { FC, useRef } from 'react'
import s from './PromoRollCardKuper.module.sass'
import Image from 'next/image'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { TypePromoItemKuper } from '@features/PromoRoll/types/types'
import AdvDetailed from '../../../Common/AdvDetailed/AdvDetailed'
import Link from 'next/link'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'
import { AdvertBadge } from '@shared/ui/Feedback/AdvertBadge'

interface Props {
  data: TypePromoItemKuper
  className?: string
  onClick: () => void
}

const PromoRollCardKuper: FC<Props> = ({ data, onClick, className = '' }) => {
  const { isMobile } = useClientResponsive()

  return (
    <ErrorBoundary>
      <div className={s.header}>
        <AdvertBadge sizes={'42x18'} />
        <AdvDetailed>
          <AdvDetailed.Button className={s.button} />
          <AdvDetailed.Popup
            description={'Рекламодатель ООО «Купер», 18 ОГРН 116784738113 Юр.адрес Санкт-Петербург'}
            token={'123'}
          />
        </AdvDetailed>
      </div>

      <Link
        href={data.href}
        className={`${s.card} ${className}`}
        target='_blank'
        onClick={onClick}
        scroll={false}
        title={data.description}>
        <Image
          src={isMobile ? data.src.mobile : data.src.desktop}
          alt={data.description}
          width={isMobile ? 267 : 402}
          height={isMobile ? 96 : 140}
        />
      </Link>
    </ErrorBoundary>
  )
}

export default PromoRollCardKuper
